import { ImageOff } from "lucide-react";
import type { Store } from "@/lib/api/types";
import { Card, CardContent } from "@/components/ui/card";
import { StatusBadge } from "@/components/StatusBadge";
import { MerchantDashboardLink } from "@/components/MerchantDashboardLink";
import { formatDate } from "@/lib/utils/date";

type StoreCardProps = {
  store: Store;
  onClick: () => void;
};

export function StoreCard({ store, onClick }: StoreCardProps) {
  return (
    <Card className="cursor-pointer transition-shadow hover:shadow-md" onClick={onClick}>
      {/* Cover image */}
      {store.cover_image_url ? (
        <div className="h-28 overflow-hidden rounded-t-xl">
          <img
            src={store.cover_image_url}
            alt={store.name}
            className="w-full h-full object-cover"
          />
        </div>
      ) : (
        <div className="h-28 rounded-t-xl bg-muted flex items-center justify-center">
          <ImageOff className="size-8 text-muted-foreground/30" />
        </div>
      )}

      <CardContent className="p-3 space-y-2">
        <div className="flex items-start justify-between gap-2">
          <p className="font-semibold text-sm leading-tight line-clamp-2">{store.name}</p>
          <div className="flex shrink-0 items-center gap-1.5">
            <MerchantDashboardLink storeId={store.id} stopPropagation />
            <StatusBadge status={store.status} visible={store.visible} className="text-[10px]" />
          </div>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-xs text-muted-foreground capitalize">{store.category}</span>
          <span className="text-xs text-muted-foreground">{formatDate(store.created_at)}</span>
        </div>

        {store.address_line1 && (
          <p className="text-xs text-muted-foreground truncate">{store.address_line1}</p>
        )}
        {store.city && <p className="text-xs text-muted-foreground">{store.city}</p>}

        {store.status === "active" && store.approved_at === null && (
          <span
            className="inline-block rounded-full border px-2 py-0.5 text-[10px] font-medium"
            style={{
              color: "#F59E0B",
              borderColor: "#F59E0B",
              backgroundColor: "#F59E0B22",
            }}
          >
            Pending Approval
          </span>
        )}
      </CardContent>
    </Card>
  );
}
